var map = {
	"./application/mobile/preferences.json": [
		4462,
		4462
	],
	"./application/native_mobile/preferences.json": [
		15536,
		5536
	],
	"./application/web/preferences.json": [
		7624,
		7624
	],
	"./prefab/default/preferences.json": [
		47711,
		7711
	],
	"./templatebundle/mobile/preferences.json": [
		54834,
		4834
	],
	"./templatebundle/web/preferences.json": [
		74964,
		4964
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 44255;
module.exports = webpackAsyncContext;